import { render, staticRenderFns } from "./segments-navbar.vue?vue&type=template&id=08e9b308"
import script from "./segments-navbar.vue?vue&type=script&lang=js"
export * from "./segments-navbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports